namespace GeniuzPOS.ReportMasterData {
    export interface Report_1336Form {
    }

    export class Report_1336Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1336';
    }
}
